const mediaItems = [
  {
    id: 1,
    title: '深度揭秘：2025娱乐圈资本洗牌背后的推手',
    duration: '18:24',
    views: '28万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20visual%20with%20warm%20coral%20and%20black%20gradients%2C%20investigative%20documentary%20theme%2C%20dramatic%20lighting%20with%20cinematic%20feel%2C%20geometric%20patterns%2C%20dark%20moody%20tone%2C%20sophisticated%20style%2C%20no%20text&width=800&height=500&seq=media-1-chigua&orientation=landscape',
  },
  {
    id: 2,
    title: '从顶流到查无此人：那些消失的明星去了哪里',
    duration: '22:10',
    views: '21万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20amber%20and%20cream%20tones%2C%20documentary%20film%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20layered%20textures%2C%20mysterious%20atmosphere%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=media-2-chigua&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺节目套路大全：编剧亲述那些你不知道的内幕',
    duration: '15:48',
    views: '19万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20abstract%20visual%20with%20warm%20red%20and%20gold%20gradients%2C%20television%20studio%20theme%2C%20dramatic%20spotlight%20effects%2C%20geometric%20abstract%20shapes%2C%20entertainment%20industry%20aesthetic%2C%20no%20text&width=800&height=500&seq=media-3-chigua&orientation=landscape',
  },
  {
    id: 4,
    title: '网红产业链全解析：从素人到百万粉丝的成本',
    duration: '25:33',
    views: '16万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20social%20media%20theme%20visual%20with%20warm%20coral%20and%20charcoal%20tones%2C%20digital%20content%20creation%20aesthetic%2C%20geometric%20pattern%20overlay%2C%20dramatic%20lighting%2C%20editorial%20magazine%20style%2C%20no%20text&width=800&height=500&seq=media-4-chigua&orientation=landscape',
  },
  {
    id: 5,
    title: '年度十大娱乐事件盘点：那些刷爆你朋友圈的瓜',
    duration: '12:05',
    views: '14万',
    image: 'https://readdy.ai/api/search-image?query=Year%20in%20review%20abstract%20collage%20with%20warm%20coral%20red%20and%20gold%20accents%2C%20retrospective%20theme%2C%20layered%20geometric%20elements%2C%20dramatic%20editorial%20style%2C%20bold%20composition%2C%20no%20text&width=800&height=500&seq=media-5-chigua&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">深度视频</h2>
          <p className="text-foreground-500 text-sm">专业团队出品，用视频带你深入了解每一个爆料</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 bg-background-950/80 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views}次观看
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}